/**
 * @module app.cm
 */

import { IHouseholdSearchFilters } from 'app/cd/services/household-service';
import { IMemberSearchFilters } from "app/cd/services/member-service";
import { ICaseSearchFilters } from "app/cm/services/case-service";

export class ManageCasesPageContext {

    public memberSearchFilters: IMemberSearchFilters = {};

    public caseSearchFilters: ICaseSearchFilters = {};

    public householdSearchFilters: IHouseholdSearchFilters = {};

    public clear(): void {
        this.memberSearchFilters = {};
        this.caseSearchFilters = {};
        this.householdSearchFilters = {};
    }

}
